<template>
    <edit-number
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :readonly="readonly"
        :error="error"
        :error-messages="errorMessagesValue"
        :reverse="reverse"
        :label="labelValue || $t('number')"
        :hide-details="hideDetails"
        :hide-label="hideLabel"
        :hide-placeholder="hidePlaceholder"
        :description="descriptionValue"
        :placeholder="placeholderValue"
        :hint="hintValue"
        :name="name"
        :options="options"
        :mask="mask"
        @focus="$emit('focus')"
        @blur="$emit('blur', $event)"
        @keyup="$emit('keyup')"
        @keydown="$emit('keydown')"
        @click="$emit('click')"
    >
        <template #prepend>
            <slot name="prepend" />
        </template>
        <template #prepend-inner>
            <span v-if="prependText">{{ prependText }}</span>
            <slot name="prepend-inner" />
        </template>
        <template #append>
            <span v-if="appendText">{{ appendText }}</span>
            <slot name="append" />
        </template>
        <template #append-outer>
            <slot name="append-outer" />
        </template>
    </edit-number>
</template>

<script>
import BaseField from './BaseField';
export default {
    name: 'Number',
    extends: BaseField,
    props: {
        reverse: {
            type: Boolean,
            default: false
        },
        decimals: {
            type: Number,
            default: 8
        }
    },
    computed: {
        options() {
            const options = {};

            if (this.decimals !== null) {
                options.decimals = this.decimals;
            }

            return options;
        }
    }
};
</script>
